module.exports = __webpack_public_path__ + "img/almere_leidingen.86f0fbd4.png";